import React from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { valToPercent } from '../../../../helpers/value'

const CustomValue = ({ val }) => {
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <Element className="dFlex alignItemsCenter positionRelative">
      <Element
        style={{
          backgroundColor: '#006AA6',
          width: `${val * 100}% `,
          height: '100%',
        }}
      >
        &nbsp;
      </Element>
      <Element
        style={{
          backgroundColor: '#EDF5FE',
          width: `${100 - val * 100}% `,
          height: '100%',
          color: '#191D25',
        }}
      >
        &nbsp;
      </Element>
      <Element
        style={{
          textAlign: 'center',
          position: 'absolute',
          left: 0,
          right: 0,
          width: '100%',
          color: '#9dc6e7',
        }}
      >
        {valToPercent(val, locale)}
      </Element>
    </Element>
  )
}

export default CustomValue
